var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"data-anim":"base","shown":_vm.wrapperClipped ? 'shown' : 'closed'}},[_c('div',{staticClass:"circle",attrs:{"data-anim":"base left","step":("left-step-" + _vm.deg)}}),_vm._v(" "),_c('div',{staticClass:"circle",attrs:{"data-anim":"base right","step":("right-step-" + _vm.deg)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae8a5e8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PairingProgressIndicator.vue
// module id = 422
// module chunks = 1